<script>
    import Router from "svelte-spa-router";
    import Models from "./components/Models.svelte";
    import Home from "./components/Home.svelte";
    import Model from "./components/Model.svelte";

    const routes = { "/": Home, "/models": Models, "/models/:id": Model };
</script>

<main>
    <Router {routes} />
</main>
